import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
// import SwiperCore, { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

// SwiperCore.use([Navigation]);

const countries = [
  { name: "New Zealand", id: "nz" },
  { name: "Australia", id: "au" },
  { name: "Canada", id: "ca" },
];

const citiesByCountry = {
  nz: ["Auckland", "Christchurch", "Wellington"],
  au: ["Sydney", "Perth", "Melbourne", "Darwin", "Brisbane"],
  ca: ["Toronto", "Regina", "Saskatoon", "Prince Island", "Vancouver"],
};

const services = [
  "Beauty",
  "Nails",
  "Barbers",
  "Spa & souna",
  "Massages",
  "Tattoo",
  "Restaurant",
  "Take away",
];

const BrowseByCity = () => {
  const [selectedCountry, setSelectedCountry] = useState("nz");

  useEffect(() => {
    const prev = document.querySelector(".swiper-button-prev");
    const next = document.querySelector(".swiper-button-next");
    if (prev) prev.classList.add("text-red-600");
    if (next) next.classList.add("text-red-600");
  }, [selectedCountry]);

  const renderCity = (city) => (
    <div key={city} className="bg-dry rounded-lg shadow p-4 w-full max-w-xs">
      <h3 className="font-semibold mb-2 text-text">{city}</h3>
      <ul className="space-y-1 text-sm text-textGray">
        {services.map((service, i) => (
          <li key={i} className="hover:underline cursor-pointer">
            {service} in {city}
          </li>
        ))}
      </ul>
    </div>
  );

  const cities = citiesByCountry[selectedCountry];

  return (
    <section className="px-4 py-12 mx-auto bg-gradient-to-t from-black to-dry">
      {/* Country Tabs */}
      <div className="max-w-7xl  mx-auto">
        <div className="flex flex-wrap gap-3 overflow-x-auto pb-4 mb-6 border-b border-border">
          {countries.map((country) => (
            <button
              key={country.id}
              onClick={() => setSelectedCountry(country.id)}
              className={`px-4 py-1 text-sm font-medium rounded-full transition-all duration-150 ${
                selectedCountry === country.id
                  ? "bg-red-500 text-text"
                  : "text-textGray hover:text-text"
              }`}
            >
              {country.name}
            </button>
          ))}
        </div>

        {/* Swiper with navigation arrows */}
        <Swiper
          spaceBetween={24}
          slidesPerView={4}
          navigation={false}
          breakpoints={{
            320: { slidesPerView: 1.2 },
            640: { slidesPerView: 2.2 },
            768: { slidesPerView: 3.2 },
            1024: { slidesPerView: 4 },
          }}
        >
          {cities.map((city) => (
            <SwiperSlide key={city}>{renderCity(city)}</SwiperSlide>
          ))}

          {/* <div className="swiper-button-prev " />
          <div className="swiper-button-next " /> */}
        </Swiper>
      </div>
    </section>
  );
};

export default BrowseByCity;
